<div style="text-align: center;">
    <h2>This site down until 08-Nov-2022 13:00 hrs (UTC)</h2>
    <img src="../../../../assets/images/loader.gif"/>
</div>